const StatusBadge = ({ status }) => {

  const colors = {
    Pending: "bg-slate-200 text-slate-700",
    "In Progress": "bg-blue-100 text-blue-700",
    Completed: "bg-indigo-100 text-indigo-700",
    "Under Review": "bg-yellow-100 text-yellow-700",
    Approved: "bg-green-100 text-green-700",
    Locked: "bg-gray-300 text-gray-800"
  };

  return (
    <span className={`px-2 py-1 rounded text-xs font-semibold ${colors[status]}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
